import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  Autocomplete,
  FormControl,
  InputLabel,
  Checkbox,
  Chip,
  Typography,
} from "@mui/material";
import apiService from "../../service/apiService";
import { FaRegEdit, FaEye, FaTrash } from "react-icons/fa";
import { Pagination } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import UploadIcon from '@mui/icons-material/Upload';
import { Download } from "@mui/icons-material";
import { format, parseISO } from "date-fns";
import { FormHelperText } from "@mui/material";
import { useCallback } from "react";
import { debounce } from "lodash";

const Farmerfieldday = () => {
  const navigate = useNavigate();
  
  // Essential state variables only
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [pageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [alldata, setAllData] = useState([]);
  const [District, setDistrict] = useState("");
  const [Block, setBlock] = useState("");
  const [dates, setDate] = useState("");
  const [Venue, setVenue] = useState("");
  const [Designation, setDesignation] = useState("");
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [ResourcePerson, setResourcePerson] = useState('');
  const [farmerFieldDaysId, setFarmerFieldDaysId] = useState(null);
  const [seasonName, setSeasonName] = useState("");
  const [mipNames, setMipNames] = useState('');
  const [seedNames, setSeedNames] = useState('');
  const [seedVarietyNames, setSeedVarietyNames] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());
  const [farmers, setFarmers] = useState([]);
  const [mipOptions, setMipOptions] = useState([]);
  const [producerGroupOptions, setProducerGroupOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [blockOptions, setBlockOptions] = useState([]);
  const [seedVarietyOptions, setSeedVarietyOptions] = useState([]);
  const [years, setYears] = useState([]);
  const [errors, setErrors] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const [dist, setDist] = useState(loginData?.districtId ? loginData.districtId : 0);
  const [blk, setBlk] = useState(loginData?.blockId ? loginData.blockId : 0);
  
  const [formData, setFormData] = useState({
    blockId: "",
    date: "",
    seedVarietyIds: [],
    venue: "",
    districtId: "",
    farmerIds: [],
    producerGroupIds: [],
    designation: "",
    farmerFieldDaysId: "",
    resourcesPerson: "",
    mipIds: [],
  });

  // Essential useEffects
  useEffect(() => {
    const fetchSeedVarieties = async () => {
      try {
        const response = await apiService.get("/seed-varieties/get-all");
        if (response.status === 200) {
          setSeedVarietyOptions(response.data);
        }
      } catch (error) {
        console.error("Error fetching seed varieties:", error);
      }
    };
    fetchSeedVarieties();
  }, []);

  useEffect(() => {
    if (formData.districtId) {
      apiService.get(`/master/get-block-by-district/${formData.districtId}`)
        .then((response) => {
          if (response.data.status) {
            setBlockOptions(response.data.body.blocks || []);
            const blockExists = response.data.body.blocks.some(
              (block) => block.blockId === formData.blockId
            );
            if (!blockExists) {
              setFormData((prev) => ({ ...prev, blockId: "" }));
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching blocks:", error);
        });
    } else {
      setBlockOptions([]);
      setFormData((prev) => ({ ...prev, blockId: "" }));
    }
  }, [formData.districtId]);

  useEffect(() => {
    if (formData.blockId) {
      apiService.get(`/master/get-mip-by-block/${formData.blockId}`)
        .then((response) => {
          if (response.data.status) {
            setMipOptions(response.data.body || []);
            const validMipIds = response.data.body.map(mip => mip.mipid);
            setFormData((prev) => ({
              ...prev,
              mipIds: prev.mipIds.filter(id => validMipIds.includes(id))
            }));
          }
        })
        .catch((error) => {
          console.error("Error fetching MIPs:", error);
        });
    } else {
      setMipOptions([]);
      setFormData((prev) => ({ ...prev, mipIds: [] }));
    }
  }, [formData.blockId]);

  const fetchDistricts = async () => {
    try {
      const response = await apiService.get("/districts/get-all");
      setDistrictOptions(response.data);
    } catch (error) {
      console.error("Error fetching districts:", error);
    }
  };

  const fetchProducerGroups = async () => {
    try {
      const response = await apiService.get("/producer-groups/get-all");
      setProducerGroupOptions(response.data);
    } catch (error) {
      console.error("Error fetching producer groups:", error);
    }
  };

  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);
      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };

  const fetchAllDist = async () => {
    try {
      const response = await apiService.get('/districts/get-all');
      const currentDist = loginData?.districtId ? loginData.districtId : 0;
      if (currentDist) {
        const defDist = response.data.find((dis) => dis.districtId === currentDist);
        setDistrict(defDist ? defDist.districtName : "");
      }
    } catch (error) {
      setDistrict("");
      console.error('Error fetching districts:', error);
    }
  };

  const fetchAllBlocks = async () => {
    try {
      const response = await apiService.get(`/master/get-block-by-district/${dist}`);
      const currentBlock = loginData?.blockId ? loginData.blockId : 0;
      if (currentBlock) {
        const defBlock = response.data.body.blocks.find((blk) => blk.blockId === currentBlock);
        setBlock(defBlock ? defBlock.blockName : "");
      }
    } catch (error) {
      setBlock("");
      console.error("Error fetching blocks:", error);
    }
  }

  useEffect(() => {
    if (dist > 0) {
      fetchAllBlocks();
    }
  }, [dist]);

  useEffect(() => {
    fetchDistricts();
    fetchProducerGroups();
    fetchYears();
    fetchAllDist();
  }, []);

  useEffect(() => {
    const fetchFarmers = async () => {
      try {
        const response = await apiService.post("/farmers/detail", {
          ProducerGroupId: formData.producerGroupIds,
        });
        const fetchedFarmers = response.data;
        setFarmers((prevFarmers) => {
          const existingFarmers = prevFarmers.filter((farmer) =>
            formData.farmerIds.includes(farmer.FarmerId)
          );
          const missingFarmers = formData.farmerIds
            .filter((farmerId) => !fetchedFarmers.some((f) => f.FarmerId === farmerId))
            .map((farmerId) => ({
              FarmerId: farmerId,
              FarmerName: `Farmer ${farmerId}`,
            }));
          return [...existingFarmers, ...fetchedFarmers, ...missingFarmers].reduce((acc, farmer) => {
            if (!acc.some((f) => f.FarmerId === farmer.FarmerId)) {
              acc.push(farmer);
            }
            return acc;
          }, []);
        });
      } catch (error) {
        console.error("Error fetching Farmer data:", error);
      }
    };

    if (formData.producerGroupIds.length > 0) {
      fetchFarmers();
    } else {
      setFarmers([]);
    }
  }, [formData.producerGroupIds, formData.farmerIds]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name === 'producerGroupIds') {
      fetchFarmers(value);
    }
  };

  const fetchFarmers = (selectedProducerGroupIds) => {
    if (selectedProducerGroupIds.length === 0) {
      setFarmers([]);
      return;
    }

    apiService.post('/farmers/detail', {
      ProducerGroupId: selectedProducerGroupIds,
    })
      .then((response) => {
        setFarmers(response.data);
      })
      .catch((error) => {
        console.error('Error fetching farmer data:', error);
      });
  };

  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  const fetchData = async () => {
    try {
      const payload = {
        blockId: Block || 0,
        date: dates ? formatDate(dates) : "",
        designation: Designation || "",
        districtName: District || "",
        resourcesPerson: ResourcePerson || "",
        venue: Venue || "",
        mipName: mipNames || "",
        seasoned: seasonName || 0,
        seedName: seedNames || "",
        seedvarietyId: seedVarietyNames || 0,
        year: year,
        pageNumber: page,
        pageSize: 10,
      };

      const response = await apiService.post(
        "/farmer-field-days/get-farmer-field-days",
        payload
      );
      const data = response.data.body.data;
      const formattedData = data.map((item) => ({
        id: item.farmerFieldDaysId,
        farmerFieldDaysId: item.farmerFieldDaysId,
        seasonName: item.seasonName || "",
        District: item.districtName || "",
        Block: item.blockName || "",
        mipNames: item.mipNames || "",
        Venue: item.venue || "",
        Date: item.date || "",
        seedNames: item.seedNames || "",
        seedVarietyNames: item.seedVarietyNames || "",
        farmers: item.farmers || "0",
        ResourcePerson: item.resourcesPerson || "",
        Designation: item.designation || "",
        yearValue : item.yearValue || "",
        producerGroups : item.producerGroups || "0",
        male : item.male || "0",
        female : item.female || "0",
        sc : item.sc || "0",
        st : item.st || "0",
        obc : item.obc || "0",
        gen : item.gen || "0",
        govtOfficial: item.govtOfficial || "0",
        others : item.others || "0"
      }));

      setAllData(formattedData);
      setTotalitems(response.data.body.recordsCount);
      setTotalpage(response.data.body.pageCount);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllData([]);
      setTotalitems(0);
      setTotalpage(0);
    }
  };

  const debouncedFetchData = useCallback(debounce(fetchData, 500), [
    page,
    pageSize,
    District,
    Block,
    mipNames,
    dates,
    Venue,
    ResourcePerson,
    Designation,
    seasonName,
    seedNames,
    seedVarietyNames,
    year,
  ]);

  useEffect(() => {
    debouncedFetchData();
    return () => debouncedFetchData.cancel();
  }, [debouncedFetchData]);

  const handleView = async (data) => {
    try {
      navigate("/childffd", { state: { farmerFieldDaysId: data.farmerFieldDaysId } });
    } catch (error) {
      console.error("Error navigating:", error);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleOpenEdit = async (data) => {
    const { farmerFieldDaysId } = data;
    try {
      setFarmerFieldDaysId(data.farmerFieldDaysId);
      const response = await apiService.get(`/farmer-field-days/${farmerFieldDaysId}`);
      if (response.status === 200) {
        const fetchedData = response.data;
        setFormData({
          blockId: fetchedData.blockId || "",
          date: fetchedData.date || "",
          seedVarietyIds: fetchedData.seedVarietyIds || [],
          venue: fetchedData.venue || "",
          districtId: fetchedData.districtId || "",
          farmerIds: fetchedData.farmerIds || [],
          producerGroupIds: fetchedData.producerGroupIds || [],
          designation: fetchedData.designation || "",
          farmerFieldDaysId: fetchedData.farmerFieldDaysId || "",
          resourcesPerson: fetchedData.resourcesPerson || "",
          mipIds: fetchedData.mipIds || [],
        });
        setOpen(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSaveEdit = async () => {
    if (validateForm()) {
      const confirmUpdate = window.confirm("Are you sure you want to update the details?");
      if (!confirmUpdate) return;

      try {
        const { farmerFieldDaysId } = formData;
        const formattedDate = new Date(formData.date)
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-");

        const payload = {
          farmerIds: formData.farmerIds,
          date: formattedDate,
          venue: formData.venue,
          resourcePerson: formData.resourcesPerson,
          districtId: formData.districtId,
          blockId: formData.blockId,
          producerGroupIds: (formData.producerGroupIds || []).filter(Boolean),
          mipIds: (formData.mipIds || []).filter(Boolean),
          designation: formData.designation,
          seedVarietyIds: (formData.seedVarietyIds || []).filter(Boolean),
        };

        const response = await apiService.put(
          `/farmer-field-days/update/${farmerFieldDaysId}`,
          payload
        );

        if (response.status === 200 || response.status === 201) {
          alert("Farmer Field Days updated successfully.");
          setOpen(false);
          fetchData();
        } else {
          alert("Failed to update Farmer Field Days details.");
        }
      } catch (error) {
        console.error("Error while saving data:", error);
        alert("An error occurred while saving the changes. Please try again.");
      }
    }
  };

  const handleDelete = async (data) => {
    try {
      const confirmDelete = window.confirm("Are you sure you want to delete this entry?");
      if (!confirmDelete) return;

      const response = await apiService.delete(`/farmer-field-days/${data.farmerFieldDaysId}`);
      if (response.status === 200) {
        fetchData();
      }
    } catch (error) {
      console.error("Error deleting Farmer Field Day:", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }

    return paginationItems;
  };

  const handleDownloadExcel = () => {
    const headers = [
      "SlNo", "Season", "District", "Block", "MIP", "Venue", "Date",
      "Seed", "SeedVariety", "Farmer", "ProducerGroup", "ResourcesPerson", "Designation",
    ];
    const worksheetData = [headers];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "sheet1");
    XLSX.writeFile(workbook, "Farmer_field_days_format.xlsx");
  };

  const exportToExcel = async () => {
    const headers = [
      "SL", "Year", "Season", "District", "Block", "MIP", "Date", "Venue", 
      "Crop", "Variety", "PG(no.)", "Farmer(no.)", "Male(no.)", "Female(no.)", 
      "SC(no.)", "ST(no.)", "OBC(no.)", "GEN(no.)", "Resource Person Name", "Designation"
    ];

    try {
      const payload = {
        blockId: Block || 0,
        date: dates || "",
        designation: Designation || "",
        districtName: District || "",
        resourcesPerson: ResourcePerson || "",
        venue: Venue || "",
        mipName: mipNames || "",
        seasoned: seasonName || 0,
        seedName: seedNames || "",
        seedvarietyId: seedVarietyNames || 0,
        year: year || "",
        pageNumber: page,
        pageSize: 10000000,
      };

      const response = await apiService.post("/farmer-field-days/get-farmer-field-days", payload);

      if (response?.data?.body?.data) {
        const data = response.data.body.data;
        console.log("result data are-----------", data );
        const formattedData = data.map((item, index) => [
          index + 1,
          item.year || "", 
          item.seasonName || "",
          item.districtName || "",
          item.blockName || "",
          item.mipNames || "",
          item.date ? format(parseISO(item.date), "dd-MM-yyyy") : "", // Format date
          item.venue || "",
          item.seedNames || "", // Crop
          item.seedVarietyNames || "", // Variety
          item.producerGroups || "", // PG(no.) - assuming this field exists in API
          item.farmers || 0, // Farmer(no.)
          item.male || 0, // Male(no.)
          item.female || 0, // Female(no.)
          item.sc || 0, // SC(no.)
          item.st || 0, // ST(no.)
          item.obc || 0, // OBC(no.)
          item.gen || 0, // GEN(no.)
          item.resourcesPerson || "", // Resource Person Name
          item.designation || ""
        ]);

        const worksheetData = [headers, ...formattedData];
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        
        // Set column widths for better readability
        worksheet['!cols'] = headers.map(() => ({ wch: 15 }));
        
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "FarmerFieldDays");
        XLSX.writeFile(workbook, `Farmer_field_days_${year}.xlsx`);
        
        console.log("Excel file successfully exported!");
      } else {
        console.error("No data received or invalid response structure.");
      }
    } catch (error) {
      console.error("Error exporting data to Excel:", error);
    }
  };

  const handleExcelUpload = (event) => {
    const file = event.target.files[0];
    if (!file) {
      alert("Please select a file.");
      return;
    }

    if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
      alert("Please upload a valid Excel file.");
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const formData = new FormData();
      formData.append("file", file);

      apiService.post('/upload/fielddays-upload', formData, {
        headers: {
          'accept': '*/*',
          'Content-Type': 'multipart/form-data',
        }
      })
        .then(() => {
          alert("File uploaded successfully!");
          fetchData();
        })
        .catch((error) => {
          console.error('Error uploading file:', error);
          alert("Error uploading file");
        });
    };

    reader.onerror = () => {
      alert("Error reading file");
    };

    reader.readAsBinaryString(file);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.blockId) newErrors.blockId = "Block is required";
    if (!formData.date) newErrors.date = "Date is required";
    if (!formData.seedVarietyIds || formData.seedVarietyIds.length === 0) newErrors.seedVarietyIds = "At least one Seed Variety is required";
    if (!formData.venue) newErrors.venue = "Venue is required";
    if (!formData.resourcesPerson) newErrors.resourcesPerson = "Resource Person is required";
    if (!formData.producerGroupIds || formData.producerGroupIds.length === 0) newErrors.producerGroupIds = "At least one Producer Group is required";
    if (!formData.mipIds || formData.mipIds.length === 0) newErrors.mipIds = "At least one MIP is required";
    if (!formData.designation) newErrors.designation = "Designation is required";
    if (!formData.farmerIds || formData.farmerIds.length === 0) newErrors.farmerIds = "At least one Farmer is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <Box style={{
      backgroundColor: "#f8f9fa",
      overflowY: "auto"
    }}>
      {/* Header - Same design as capacitybuild.jsx */}
      <div style={{
        backgroundColor: "#ffffff",
        borderBottom: "3px solid #007bff",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
      }}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center py-3 px-4">
            <div className="d-flex align-items-center">
              <div>
                <h1 style={{
                  fontSize: "1.8rem",
                  fontWeight: "600",
                  color: "#2c3e50",
                  margin: "0"
                }}>
                  Farmer Field Day Management
                </h1>
              </div>
            </div>

            <div className="d-flex align-items-center gap-3">
              <div className="d-flex align-items-center">
                <label style={{
                  fontWeight: "500",
                  color: "#495057",
                  marginRight: "10px",
                  fontSize: "14px"
                }}>
                  Year:
                </label>
                <select
                  className="form-select"
                  value={year || 0}
                  onChange={(e) => setYear(Number(e.target.value))}
                  style={{
                    border: "1px solid #ced4da",
                    borderRadius: "6px",
                    padding: "6px 12px",
                    fontSize: "14px",
                    minWidth: "100px",
                    backgroundColor: "#fff"
                  }}
                >
                  <option value={0} disabled>Select Year</option>
                  {years.map((yr) => (
                    <option key={yr.yearId} value={yr.yearValue}>
                      {yr.yearValue}
                    </option>
                  ))}
                </select>
              </div>

              <Button
                variant="contained"
                onClick={() => navigate("/addffd")}
                style={{
                  backgroundColor: "#28a745",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                + Add New
              </Button>
              <Button
                variant="contained"
                startIcon={<Download />}
                onClick={exportToExcel}
                style={{
                  backgroundColor: "#007bff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                Export Excel
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content - Same design as capacitybuild.jsx */}
      <div className="container-fluid" style={{ padding: "20px" }}>
        <div style={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 160px)"
        }}>
          <div style={{
            flex: "1",
            overflowY: "auto",
            overflowX: "auto"
          }}>
            <div className="table-responsive">
              <table className="table table-hover mb-0" style={{
                minWidth: "1800px",
                backgroundColor: "#fff"
              }}>
                <thead style={{
                  backgroundColor: "#007bff",
                  color: "white",
                  position: "sticky",
                  top: "0",
                  zIndex: "10"
                }}>
                  <tr>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      textAlign: "center",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "60px"
                    }}>
                      SL
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      textAlign: "center",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "60px"
                    }}>
                      Year
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Season
                      <br />
                      <select
                        className="form-control form-control-sm mt-2"
                        value={seasonName}
                        onChange={(e) => { setSeasonName(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      >
                        <option value="">All</option>
                        <option value="Rabi">Rabi</option>
                        <option value="Kharif">Kharif</option>
                      </select>
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "140px"
                    }}>
                      District
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={District}
                        onChange={(e) => {
                          if (dist === 0) {
                            setDistrict(e.target.value);
                            setPage(1);
                          }
                        }}
                        disabled={dist > 0}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Block
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={Block}
                        onChange={(e) => {
                          if (blk === 0) {
                            setBlock(e.target.value);
                            setPage(1);
                          }
                        }}
                        disabled={blk > 0}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "150px"
                    }}>
                      MIP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={mipNames}
                        onChange={(e) => { setMipNames(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Date
                      <br />
                      <input
                        type="date"
                        className="form-control form-control-sm mt-2"
                        value={dates}
                        onChange={(e) => { setDate(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Venue
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={Venue}
                        onChange={(e) => { setVenue(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Crop
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={seedNames}
                        onChange={(e) => { setSeedNames(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "140px"
                    }}>
                      Variety
                      <br />
                      <Autocomplete
                        options={seedVarietyOptions}
                        getOptionLabel={(option) => option.varietyName || ""}
                        value={seedVarietyOptions.find((variety) => variety.seedVarietyId === seedVarietyNames) || null}
                        onChange={(event, newValue) => {
                          setSeedVarietyNames(newValue ? newValue.seedVarietyId : "");
                          setPage(1);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Search"
                            variant="outlined"
                            size="small"
                            style={{
                              backgroundColor: "#ffffff",
                              fontSize: "12px"
                            }}
                          />
                        )}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px",
                      textAlign: "center"
                    }}>
                      PG(no.)
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px",
                      textAlign: "center"
                    }}>
                      Farmer(no.)
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px",
                      textAlign: "center"
                    }}>
                      Govt. Official(no.)
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px",
                      textAlign: "center"
                    }}>
                      Others(no.)
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px",
                      textAlign: "center"
                    }}>
                      Male(no.)
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px",
                      textAlign: "center"
                    }}>
                      Female(no.)
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px",
                      textAlign: "center"
                    }}>
                      SC(no.)
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px",
                      textAlign: "center"
                    }}>
                      ST(no.)
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px",
                      textAlign: "center"
                    }}>
                      OBC(no.)
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px",
                      textAlign: "center"
                    }}>
                      GEN(no.)
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "150px"
                    }}>
                      Resource Person Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={ResourcePerson}
                        onChange={(e) => { setResourcePerson(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Designation
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={Designation}
                        onChange={(e) => { setDesignation(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      textAlign: "center",
                      minWidth: "120px"
                    }}>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: "13px" }}>
                  {alldata.map((data, index) => (
                    <tr key={index} style={{
                      backgroundColor: index % 2 === 0 ? "#f8f9fa" : "#ffffff",
                      borderBottom: "1px solid #dee2e6"
                    }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#e3f2fd";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#f8f9fa" : "#ffffff";
                      }}>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {(page - 1) * 10 + index + 1}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.yearValue}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: data.seasonName === 'Rabi' ? '#d4edda' : '#fff3cd',
                          color: data.seasonName === 'Rabi' ? '#155724' : '#856404',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "11px",
                          fontWeight: "500"
                        }}>
                          {data.seasonName}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "500"
                      }}>
                        {data.District}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.Block}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontSize: "12px"
                      }}>
                        {data.mipNames}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "500"
                      }}>
                        {data.Date ? format(parseISO(data.Date), "dd-MM-yyyy") : "N/A"}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.Venue}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.seedNames}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontSize: "12px"
                      }}>
                        {data.seedVarietyNames}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                          {data.producerGroups}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: '#007bff',
                          color: 'white',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}>
                          {data.farmers}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: '#28a745',
                          color: 'white',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}>
                          {data.govtOfficial || 0}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: '#6c757d',
                          color: 'white',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}>
                          {data.others || 0}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                          {data.male}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                          {data.female}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                          {data.sc}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                          {data.st}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                          {data.obc}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                          {data.gen}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "500"
                      }}>
                        {data.ResourcePerson}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.Designation}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center"
                      }}>
                        <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                          <button
                            className="btn btn-sm btn-info"
                            onClick={() => handleView(data)}
                            title="View"
                            style={{
                              padding: "4px 8px",
                              fontSize: "12px"
                            }}
                          >
                            <FaEye />
                          </button>
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() => handleOpenEdit(data)}
                            title="Edit"
                            style={{
                              padding: "4px 8px",
                              fontSize: "12px"
                            }}
                          >
                            <FaRegEdit />
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDelete(data)}
                            title="Delete"
                            style={{
                              padding: "4px 8px",
                              fontSize: "12px"
                            }}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Pagination - Same design as capacitybuild.jsx */}
        <div className='d-flex justify-content-between align-items-center py-3 px-3' style={{
          backgroundColor: "#f8f9fa",
          borderTop: "1px solid #dee2e6"
        }}>
          <div>
            <span style={{
              color: "#6c757d",
              fontSize: "14px"
            }}>
              Showing <strong>{(page - 1) * 10 + 1}</strong> to <strong>{Math.min(page * 10, totalItems)}</strong> of <strong>{totalItems}</strong> entries
            </span>
          </div>
          <div>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

      {/* Edit Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Edit Farmer Field Days</DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="normal" error={!!errors.districtId}>
            <Autocomplete
              options={districtOptions}
              getOptionLabel={(option) => option.districtName || ""}
              value={districtOptions.find((district) => district.districtId === formData.districtId) || null}
              onChange={(event, newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  districtId: newValue ? newValue.districtId : "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={<>District <span style={{ color: "red" }}>*</span></>}
                  variant="outlined"
                  error={!!errors.districtId}
                  helperText={errors.districtId}
                />
              )}
            />
          </FormControl>

          <FormControl fullWidth margin="normal" error={!!errors.blockId}>
            <Autocomplete
              options={blockOptions}
              getOptionLabel={(option) => option.blockName}
              value={blockOptions.find((block) => block.blockId === formData.blockId) || null}
              onChange={(event, newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  blockId: newValue ? newValue.blockId : "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={<>Block <span style={{ color: "red" }}>*</span></>}
                  variant="outlined"
                  error={!!errors.blockId}
                  helperText={errors.blockId}
                />
              )}
            />
          </FormControl>

          <FormControl fullWidth margin="normal" error={!!errors.mipIds}>
            <Autocomplete
              multiple
              options={mipOptions}
              getOptionLabel={(option) => option.mipname}
              value={mipOptions.filter((mip) => formData.mipIds.includes(mip.mipid))}
              onChange={(event, newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  mipIds: newValue.map((mip) => mip.mipid),
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={<>MIPs <span style={{ color: "red" }}>*</span></>}
                  variant="outlined"
                  error={!!errors.mipIds}
                  helperText={errors.mipIds || "Required"}
                />
              )}
            />
          </FormControl>

          <TextField
            name="date"
            label={<>Date <span style={{ color: "red" }}>*</span></>}
            type="date"
            fullWidth
            value={formData.date}
            onChange={(e) => setFormData({ ...formData, date: e.target.value })}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            error={!!errors.date}
            helperText={errors.date}
          />

          <FormControl fullWidth margin="dense">
            <InputLabel id="seed-variety-label">
              Seed Varieties <span style={{ color: "red" }}>*</span>
            </InputLabel>
            <Select
              labelId="seed-variety-label"
              label={<>Seed Varieties <span style={{ color: "red" }}>*</span></>}
              multiple
              name="seedVarietyIds"
              value={formData.seedVarietyIds || []}
              onChange={(e) => {
                setFormData((prev) => ({ ...prev, seedVarietyIds: e.target.value }));
              }}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((id) => {
                    const variety = seedVarietyOptions.find((v) => v.seedVarietyId === id);
                    return variety ? <Chip key={id} label={variety.varietyName} /> : null;
                  })}
                </Box>
              )}
              variant="outlined"
            >
              {seedVarietyOptions.map((variety) => (
                <MenuItem key={variety.seedVarietyId} value={variety.seedVarietyId}>
                  {variety.varietyName}
                </MenuItem>
              ))}
            </Select>
            {errors.seedVarietyIds && <FormHelperText>{errors.seedVarietyIds}</FormHelperText>}
          </FormControl>

          <TextField
            name="venue"
            label={<>Venue <span style={{ color: "red" }}>*</span></>}
            fullWidth
            value={formData.venue}
            onChange={(e) => setFormData({ ...formData, venue: e.target.value })}
            margin="normal"
            error={!!errors.venue}
            helperText={errors.venue}
          />

          <TextField
            name="resourcesPerson"
            label={<>Resource Person<span style={{ color: "red" }}>*</span></>}
            fullWidth
            value={formData.resourcesPerson}
            onChange={(e) => setFormData({ ...formData, resourcesPerson: e.target.value })}
            margin="normal"
            error={!!errors.resourcesPerson}
            helperText={errors.resourcesPerson}
          />

          <TextField
            name="designation"
            label={<>Designation <span style={{ color: "red" }}>*</span></>}
            fullWidth
            value={formData.designation}
            onChange={(e) => setFormData({ ...formData, designation: e.target.value })}
            margin="normal"
            error={!!errors.designation}
            helperText={errors.designation}
          />

          <FormControl fullWidth margin="dense" error={!!errors.producerGroupIds}>
            <Autocomplete
              multiple
              options={producerGroupOptions || []}
              getOptionLabel={(option) => option.pgname || ""}
              value={
                producerGroupOptions?.filter((pg) =>
                  formData.producerGroupIds?.includes(pg.producerGroupId)
                ) || []
              }
              onChange={(event, newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  producerGroupIds: newValue.map((pg) => pg.producerGroupId),
                }));
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props} key={option.producerGroupId}>
                  <Checkbox checked={selected} />
                  {option.pgname}
                </li>
              )}
              renderTags={(selected, getTagProps) =>
                selected.map((option, index) => (
                  <Chip key={option.producerGroupId} label={option.pgname} {...getTagProps({ index })} />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={<>Producer Groups<span style={{ color: "red" }}>*</span></>}
                  variant="outlined"
                  fullWidth
                  required
                  error={!!errors.producerGroupIds}
                  helperText={errors.producerGroupIds}
                />
              )}
              isOptionEqualToValue={(option, value) =>
                option.producerGroupId === value.producerGroupId
              }
            />
          </FormControl>

          <Autocomplete
            multiple
            options={farmers}
            getOptionLabel={(option) => option.FarmerName}
            value={farmers.filter((farmer) => formData.farmerIds.includes(farmer.FarmerId))}
            onChange={(event, newValue) => {
              handleChange({
                target: {
                  name: "farmerIds",
                  value: newValue.map((farmer) => farmer.FarmerId),
                },
              });
            }}
            isOptionEqualToValue={(option, value) => option.FarmerId === value.FarmerId}
            renderOption={(props, option, { selected }) => (
              <li {...props} key={option.FarmerId}>
                <Checkbox checked={selected} />
                {option.FarmerName}
              </li>
            )}
            renderTags={(selected, getTagProps) =>
              selected.map((option, index) => (
                <Chip key={option.FarmerId} label={option.FarmerName} {...getTagProps({ index })} />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={<>Farmer <span style={{ color: "red" }}>*</span></>}
                variant="outlined"
                fullWidth
                error={!!errors.farmerIds}
                helperText={errors.farmerIds}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button color="primary" onClick={handleSaveEdit}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={openDelete} onClose={handleCloseDelete}>
        <DialogTitle>Delete Entry</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this entry?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleDelete(selectedRow)} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Farmerfieldday;